// const moduleB = () => {
//   console.log("component other");
// };

import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'

import { Marquee } from '../modules/marquee.js'
// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		this.elMarquee = this.element

		this.logoMarquee = new Marquee(this.elMarquee, {})
	}
	mount() {}
	unmount() {
		if (this.logoMarquee) {
			this.logoMarquee.destroy()
		}
	}
	//
}
